import { render, staticRenderFns } from "./legalRisks.vue?vue&type=template&id=290526ac&scoped=true&"
import script from "./legalRisks.vue?vue&type=script&lang=js&"
export * from "./legalRisks.vue?vue&type=script&lang=js&"
import style0 from "./legalRisks.vue?vue&type=style&index=0&id=290526ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290526ac",
  null
  
)

export default component.exports